<form [formGroup]="paymentForm" class="admin-forms truckComponent truckowner-payment">
    <div class="accordion-class header-container">
        <h5>Truck Owner Payment</h5>
        <img src="../../../assets/img/icons8-macos-close-60.png" class="close-icons" (click)="close()">
    </div>
    <mat-divider></mat-divider>
    <div class="input-fileds-container">
        <div class="group">
            <div class="row mtb align-items-center">
                <div class="col-12">
                    <mat-form-field>
                        <mat-label>Transcation ID:</mat-label>
                        <input matInput formControlName="transaction_id" required>
                        <mat-error>Please Enter Transcation ID</mat-error>
                    </mat-form-field>
                </div>
            </div>
            <div class="row mtb align-items-center">
                <div class="col-12">
                    <mat-form-field>
                        <mat-label>Transcation Amount:</mat-label>
                        <input matInput formControlName="transaction_amount" required>
                        <mat-error>Please Enter Amount</mat-error>
                    </mat-form-field>
                </div>
            </div>
            <div class="row mtb align-items-center">
                <div class="col-12">
                    <mat-form-field>
                        <mat-datepicker-toggle matSuffix [for]="picker1">
                        </mat-datepicker-toggle>
                        <mat-datepicker #picker1></mat-datepicker>
                        <input matInput formControlName="payment_date" [matDatepicker]="picker1" placeholder="Pickup Date"
                            [min]="minDate" (click)="picker1.open()">
                        <mat-error>Please select date</mat-error>
                    </mat-form-field>
                </div>
            </div>
            <div class="row mtb align-items-center">
                <div class="col-12">
                    <mat-form-field>
                        <mat-label>Payment Type:</mat-label>
                        <mat-select formControlName="payment_type">
                            <mat-option value="">Select Payment Type</mat-option>
                            <mat-option value="rtgs">RTGS</mat-option>
                            <mat-option value="neft">NEFT</mat-option>
                            <mat-option value="imps">IMPS</mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>
            </div>
            <div class="row mtb align-items-center">
                <div class="col-12">
                    <mat-form-field>
                        <mat-label>Account Number:</mat-label>
                        <input matInput formControlName="account_no" required>
                        <mat-error>Please Enter Account Number</mat-error>
                    </mat-form-field>
                </div>
            </div>
            <div class="row mtb align-items-center">
                <div class="col-12">
                    <mat-form-field>
                        <mat-label>Bank Name:</mat-label>
                        <input matInput formControlName="bank_name" required>
                        <mat-error>Please Enter Bank Name</mat-error>
                    </mat-form-field>
                </div>
            </div>
        </div>
    </div>
    <div class="row">
        <div class="col-md-12">
            <button type="button" class="button buttonBlue" (click)="save()" [disabled]="isSaving">
                {{ isSaving ? 'Saving...' : 'Save' }}
            </button>
        </div>
    </div>
</form>